document.addEventListener('DOMContentLoaded', () => {

  // --- Check if Lenis is available ---
  if (typeof Lenis === 'undefined') {
    console.error('Lenis not loaded – check lenis.min.js');
    return;
  }

  // --- Init Lenis ---
  const lenis = new Lenis({
    duration: 1.2,          // smoothness
    smoothWheel: true,
    smoothTouch: false,
    direction: 'vertical',
  });

  // --- RAF loop ---
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  // --------------------------------------------------------------------
  // 🎯 PARALLAX : Slow elements with data-speed
  // --------------------------------------------------------------------
 const breakpoint = 768; // change if needed
  const isMobile = window.innerWidth <= breakpoint;

  const slowElements = document.querySelectorAll('[data-speed]');

  lenis.on('scroll', ({ scroll }) => {
    slowElements.forEach(el => {

      // ❌ If mobile → remove transform + skip calculations
      if (isMobile) {
        el.style.transform = '';
        return;
      }

      // ✅ Desktop → apply parallax
      const speed = parseFloat(el.dataset.speed);
      el.style.transform = `translateY(${scroll * speed}px)`;
    });
  });

});
